export const landingGroups = [
  {
    name: "Downlights",
    img: "0962c78b-058b-4725-9153-43e48eaf7b82/ee5febd1-0cc6-4518-ad30-02c182770be7.png",
    slides: [
      {
        name: "Downlight ND10",
        sku: "ND10_127XXXX_X",
        url: "https://www.nuled.mx/product-images/lote05-38.jpg",
      },
      {
        name: "Downlight  dirigible NDD12",
        sku: "NDD12_127XXXX_X",
        url: "https://www.nuled.mx/product-images/lote05-41.jpg",
      },
      {
        name: "Downlight Louver empotrado 127V 12W",
        sku: "DELOU12712XXXX_DIM_X",
        url: "https://www.nuled.mx/product-images/lote05-25.jpg",
      },
      {
        name: "Downlight trimless NDTRIM10",
        sku: "NDTRIM10_127XXXX_X",
        url: "https://www.nuled.mx/product-images/lote05-42.jpg",
      },
      {
        name: "Downlight empotrado  127V 12W",
        sku: "DE12712XXXX_DIM_X",
        url: "https://www.nuled.mx/product-images/lote05-17.jpg",
      },
    ],
    description: "Empotrados, fijos y dirigibles",
  },
  {
    name: "Exterior",
    img: "32916157-99de-4fcf-8875-4080d5282f56/2c9ca8c7-3870-48bf-b8f7-4d52a997125a.png",
    slides: [
      {
        name: "Bolardo Lighthouse 46cm 17W",
        sku: "BLHS46_30K17W_X",
        url: "https://oorhorokbvnsgoqsqwqq.supabase.co/storage/v1/object/public/product-images/32916157-99de-4fcf-8875-4080d5282f56/2c9ca8c7-3870-48bf-b8f7-4d52a997125a.png",
      },
      {
        name: "Luminaria empotrable de piso GU10",
        sku: "PISO110_GU10IP65",
        url: "https://oorhorokbvnsgoqsqwqq.supabase.co/storage/v1/object/public/product-images/8e939b44-e95b-4490-a6b9-f43fa2aa5c87/2b790a6b-79d1-4018-b51e-4a9cb3d16e8b.png",
      },
      {
        name: "Estaca Aurum",
        sku: "EAUR_30K12W_XX",
        url: "https://oorhorokbvnsgoqsqwqq.supabase.co/storage/v1/object/public/product-images/c7e2664d-7b5a-45aa-bed8-7d70ca1520ce/e0fbaa96-271b-41ab-9e9c-dad6315f5882.png",
      },
      {
        name: "Bolardo Luma 90cm",
        sku: "BLUMA90_30K12W_X",
        url: "https://oorhorokbvnsgoqsqwqq.supabase.co/storage/v1/object/public/product-images/9220e804-0797-45e7-8236-94e3cbb22cf2/598d84ef-cf21-4250-9a55-4a38e0f0a097.png",
      },
      {
        name: "Bolardo Skypath 40cm",
        sku: "BLSKYP40_30K12W_X",
        url: "https://oorhorokbvnsgoqsqwqq.supabase.co/storage/v1/object/public/product-images/1bfc6983-edb7-430c-afb5-39d7ccd102ef/3f28fbcb-1dff-43aa-a275-d59182e1ba3d.png",
      },
    ],
    description: "Luz para jardines y fachadas",
  },
  {
    name: "Fuente de poder",
    img: "deebae40-2321-44b1-bf41-8ee58793a11a/0b1a11a4-a1f9-4a27-a3c0-81854990949f.jpg",
    slides: [
      {
        name: "Fuente de poder atenuable 24V, IP20 300W",
        sku: "FP127_24V300W_DIM_IP20",
        url: "https://www.nuled.mx/product-images/lote05-54.jpg",
      },
      {
        name: "Driver LED 24V - 100W - Regulable 5 en 1",
        sku: "FP127-24V-IP20-100W-DIM",
        url: "https://www.nuled.mx/product-images/lote05-47.jpg",
      },
      {
        name: "Fuente de poder atenuable 24V, IP20 100W",
        sku: "FP127_24V100W_DIM_IP20",
        url: "https://www.nuled.mx/product-images/lote05-50.jpg",
      },
      {
        name: "Driver LED 24V - 300W - Regulable 5 en 1",
        sku: "FP127-24V-IP20-300W-DIM",
        url: "https://www.nuled.mx/product-images/lote05-49.jpg",
      },
      {
        name: "Driver LED 24V - 200W - Regulable 5 en 1",
        sku: "FP127-24V-IP20-200W-DIM",
        url: "https://www.nuled.mx/product-images/lote05-48.jpg",
      },
    ],
    description: "Alimentación para cada sistema",
  },
  {
    name: "Mangueras y tiras LED",
    img: "fe029fac-de00-4623-8336-e50420035339/5d87918f-c895-4692-a66e-ed796ee36add.jpg",
    slides: [
      {
        name: "Tira LED COB 24V 6 W/m",
        sku: "TL-COB400246XX-5M-IP20",
        url: "https://www.nuled.mx/product-images/lote04-11.jpg",
      },
      {
        name: "Manguera SLIM NEÓN 24V 10 W/m",
        sku: "MLSLIM-NEON2410XX-5M-IP66",
        url: "https://www.nuled.mx/product-images/lote04-16.jpg",
      },
      {
        name: "Manguera LED COB SLIM 127V 10 W/m",
        sku: "MLSLIM-COB29612710XX-25M-IP67",
        url: "https://www.nuled.mx/product-images/lote04-15.jpg",
      },
      {
        name: "Manguera LED SMD 127V 13 W/m",
        sku: "ML-SMD12012713XX-10M-IP66",
        url: "https://www.nuled.mx/product-images/lote04-01.jpg",
      },
      {
        name: "Tira LED COB 24V 14 W/m IP66",
        sku: "TL-COB5282414XX-5M-IP66",
        url: "https://www.nuled.mx/product-images/lote04-02.jpg",
      },
    ],
    description: "Luz continua y perfiles",
  },
  {
    name: "Mini GU10",
    img: "N1DIFGU10TRIM_52MM_/1787000452669.png",
    slides: [
      {
        name: "DIFUSOR TRIMLESS MINIGU10",
        sku: "N1DIFGU10TRIM_52MM_",
        url: "https://www.nuled.mx/product-images/lote05-57.jpg",
      },
      {
        name: "MINI GU10 4W",
        sku: "MNGU10_4W_30K",
        url: "https://www.nuled.mx/product-images/lote05-56.jpg",
      },
      {
        name: "DIFUSOR TRIM MINIGU10",
        sku: "N1DIFGU10_52MM_X",
        url: "https://www.nuled.mx/product-images/lote05-58.jpg",
      },
    ],
    description: "Luminarias de formato compacto",
  },
  {
    name: "Proyectores",
    img: "291ca853-d253-40df-ab5c-8c37d64dab56/333c16c8-4d56-4e5e-a7d1-183f11380003.png",
    slides: [
      {
        name: "Proyector trim NP5",
        sku: "NP5_127XXXX_X",
        url: "https://www.nuled.mx/product-images/lote05-01.jpg",
      },
      {
        name: "Proyector trimless  NPTRIM5",
        sku: "NPTRIM5_127XXXX_X",
        url: "https://www.nuled.mx/product-images/lote05-02.jpg",
      },
    ],
    description: "Acento y dirección de la luz",
  },
  {
    name: "Riel Magnético",
    img: "EPRO48V_%2012W/1788213795466.png",
    slides: [
      {
        name: "EDGEPRO – Proyector dirigible para riel magnético 48V",
        sku: "EPRO48V_ 12W",
        url: "https://www.nuled.mx/product-images/lote02-15.jpg",
      },
      {
        name: "Luminaria lineal flexible 8 W/m, 24V de 1m",
        sku: "RM5MM24_L1M_XX100_DIM_B",
        url: "https://www.nuled.mx/product-images/lote02-01.jpg",
      },
      {
        name: "Raster riel magnetico 12 W, 48V",
        sku: "LRM48_RASF12XXXX_DIM_N",
        url: "https://www.nuled.mx/product-images/lote02-03.jpg",
      },
      {
        name: "Luminario lineal para micro riel, 30cm, 24V",
        sku: "RM5MM24_L5XX100_DIM_N",
        url: "https://www.nuled.mx/product-images/lote02-09.jpg",
      },
      {
        name: "Eclipta proyector para riel 10mm",
        sku: "ECL10MMXW_TRIAC30_N",
        url: "https://www.nuled.mx/product-images/lote02-17.jpg",
      },
    ],
    description: "Sistemas modulares de iluminación",
  },
  {
    name: "Series",
    img: "76cb7328-1998-47e8-a7d9-40e4f0b871ac/047998e6-5474-4965-bff1-cacea3b1cdda.png",
    slides: [
      {
        name: "Serie NS10",
        sku: "NS10_127XXXX_X",
        url: "https://www.nuled.mx/product-images/lote05-03.jpg",
      },
      {
        name: "Serie S2X2",
        sku: "S2X21274XXXX_DIM_X",
        url: "https://www.nuled.mx/product-images/lote05-11.jpg",
      },
      {
        name: "Serie 2 127V 6W",
        sku: "S21276XXXX_DIM_X",
        url: "https://www.nuled.mx/product-images/lote05-10.jpg",
      },
      {
        name: "Serie 5X2 127V 12W",
        sku: "S5X212712XXXX_DIM_X",
        url: "https://www.nuled.mx/product-images/lote05-16.jpg",
      },
      {
        name: "Serie S15X2",
        sku: "S15X212730XXXX_DIM_X",
        url: "https://www.nuled.mx/product-images/lote05-09.jpg",
      },
    ],
    description: "Diseño en múltiples configuraciones",
  },
];
export const landingPaths = [
  "COMPOSE",
  "Downlights",
  "Downlights/127 V",
  "Downlights/127 V/Dirigibles",
  "Downlights/127 V/Fijos",
  "Downlights/127 V/Louver",
  "Downlights/127 V/Trim",
  "Downlights/127 V/Trimless",
  "Downlights/GU10",
  "Exterior",
  "Exterior/Bolardos",
  "Exterior/Estacas",
  "Exterior/Estacas/GU10",
  "Exterior/Estacas/LED",
  "Exterior/Estacas/LED/accesorios",
  "Exterior/Piso",
  "Exterior/Wallwashers",
  "Fuente de poder",
  "Fuente de poder/IP20",
  "Fuente de poder/IP67",
  "Mangueras y tiras LED",
  "Mangueras y tiras LED/127V",
  "Mangueras y tiras LED/127V/COB",
  "Mangueras y tiras LED/127V/SMD",
  "Mangueras y tiras LED/24V",
  "Mangueras y tiras LED/24V/COB",
  "Mangueras y tiras LED/24V/Neón",
  "Mangueras y tiras LED/Accesorios",
  "Mangueras y tiras LED/Accesorios/Conectores",
  "Mangueras y tiras LED/Accesorios/Enchufes",
  "Mangueras y tiras LED/Perfilería",
  "Mangueras y tiras LED/Perfilería/Accesorios",
  "Mangueras y tiras LED/Perfilería/Esquina",
  "Mangueras y tiras LED/Perfilería/Recto",
  "Mangueras y tiras LED/Perfilería/Trimless",
  "Mangueras y tiras LED/Perfilería/Wallwasher",
  "Mini GU10",
  "Mini GU10/Dirigibles",
  "Mini GU10/Empotrar",
  "Mini GU10/Focos",
  "Mini GU10/Sobreponer",
  "Proyectores",
  "Proyectores/127v",
  "Proyectores/127v/Trim",
  "Proyectores/127v/Trimless",
  "Riel Magnético",
  "Riel Magnético/Micro Riel Magnético 24V",
  "Riel Magnético/Micro Riel Magnético 24V/Accesorios",
  "Riel Magnético/Micro Riel Magnético 24V/Downlights",
  "Riel Magnético/Micro Riel Magnético 24V/Empotrado",
  "Riel Magnético/Micro Riel Magnético 24V/Fuente de poder",
  "Riel Magnético/Micro Riel Magnético 24V/Lineal flexible",
  "Riel Magnético/Micro Riel Magnético 24V/Lineales",
  "Riel Magnético/Micro Riel Magnético 24V/Proyectores",
  "Riel Magnético/Micro Riel Magnético 24V/Raster",
  "Riel Magnético/Micro Riel Magnético 24V/Sobrepuesto",
  "Riel Magnético/Riel Magnético 10 mm 48V",
  "Riel Magnético/Riel Magnético 10 mm 48V/Accesorios",
  "Riel Magnético/Riel Magnético 10 mm 48V/Empotrado",
  "Riel Magnético/Riel Magnético 10 mm 48V/Empotrado/Accesorios",
  "Riel Magnético/Riel Magnético 10 mm 48V/Fuente de poder",
  "Riel Magnético/Riel Magnético 10 mm 48V/Proyectores",
  "Riel Magnético/Riel Magnético 10 mm 48V/Sobrepuesto",
  "Riel Magnético/Riel Magnético 10 mm 48V/Sobrepuesto/Accesorios",
  "Riel Magnético/Riel Magnético 48V",
  "Riel Magnético/Riel Magnético 48V/Accesorios",
  "Riel Magnético/Riel Magnético 48V/Empotrado",
  "Riel Magnético/Riel Magnético 48V/Fuente de Poder",
  "Riel Magnético/Riel Magnético 48V/Lineal",
  "Riel Magnético/Riel Magnético 48V/Proyectores",
  "Riel Magnético/Riel Magnético 48V/Raster",
  "Riel Magnético/Riel Magnético 48V/Sobrepuesto",
  "Series",
  "Series/127 V",
  "Series/127 V/Empotrado",
  "Series/127 V/Sobrepuesto",
];
export const categoryUrl = (path: string) =>
  `/catalogo?path=${encodeURIComponent(path)}`;
